import React, { Component } from "react";
import { connect } from "react-redux";
import { Select } from '../../ui';
import { setClientValue } from "../../../actions";
import { apersonal, options } from "../../../operations";
import { Body } from '../../Common/Form';
import Continue from "../../Common/Continue";
import Text from '../../Common/Form/Text';
import { mapSelectList } from "../../../helpers";

import iconUser from '../../../assets/icons/icon-user.svg';

class APForm_2 extends Component {

  constructor(props) {
    super(props);
    this.state = { continue: false };
    this.continueCondition = this.continueCondition.bind(this);
    this.getContent = this.getContent.bind(this);
  }

  componentDidMount() {
    const { getOccupations } = this.props;
    this.checkContinueState(null);
    getOccupations();
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkContinueState(prevState);
  }

  continueCondition() {

    const {
      occupation,
    } = this.props;

    return (
      occupation
    );
  }

  checkContinueState(prevState) {
    if (this.continueCondition()) {
      if (prevState === null || !prevState.continue) this.setState({ continue: true });
    } else {
      if (prevState === null || prevState.continue) this.setState({ continue: false });
    }
  }

  getContent() {

    const {
      name, showError,
      onValueChange, 
      occupation,
      occupations,
    } = this.props;

    return (
      <div className="APersonales-formRow-1">
        <Select
          id="occupation"
          leftIcon={iconUser}
          name="occupation"
          value={occupation}
          showAlert={showError && !occupation}
          onChange={(value) => { onValueChange('occupation', value) }}
          isLoading={!occupations}
          placeholder="Seleccione una profesión"
          options={mapSelectList(occupations)}
        />
      </div>
    );
  }

  render() {

    const { continue: toContinue } = this.state;
    const { getQuotation } = this.props;

    return (
      <div>
        <Text style={{ paddingTop: '25px'}} className="Text-question">
          ¿Cuál es tu profesión?
        </Text>
        <Body columnContent={this.getContent} />
        <Continue state={toContinue} onClick={() => {getQuotation()}}/>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    showError: state.steps.showError,

    occupation: state.client.occupation,
    occupations: state.options.occupations,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onValueChange: (type, value) => {
      dispatch(setClientValue(type, value));
    },
    getOccupations: () => {
      dispatch(options.getOccupations());
    },
    getQuotation: () => {
      dispatch(apersonal.getQuotation());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(APForm_2);